<template>
    <modal @close="$emit('close')" :isRegistration="true" :click_outside="false">
        <p class="text-white font-bold text-lg xl:-mt-10 lg:-mt-10 -mt-5 lg:text-xl xl:text-xl mt-2" slot="header">Зарегистрироваться</p>
        <div class="pb-2 lg:pb-8 xl:-mt-12 lg:-mt-12 xl:pb-8 pt-2 px-4">
            <div class="mb-2 lg:mb-8 xl:mb-8 text-sm">
                <moz-input v-model="form.name" placeholder="Имя" :error="form.errors.first('name')"></moz-input>
                <moz-input type="tel" inputmode="tel" v-model="form.phone" placeholder="Телефон" :error="form.errors.first('phone')"></moz-input>
                <moz-input type="email" v-model="form.email" placeholder="E-mail" :error="form.errors.first('email')"></moz-input>
                <p v-show="send_again" @click="sand_email" href="" class="send-again text-sm my-5 text-center underline text-brand-light text-xs cursor-pointer font-bold">Сбросить пароль</p>
                <moz-input type="password" v-model="form.password" placeholder="Пароль" :error="form.errors.first('password')"></moz-input>
                <moz-input type="password" v-model="form.password_confirmation" placeholder="Подтвердите пароль" :error="form.errors.first('password_confirmation')"></moz-input>
                <div class=" pr-1 mt-6">
                    <label class="flex justify-start  mt-1">
                        <span class="font-bold">
                            Продолжая пользоваться сервисом вы соглашаетесь с <a :href="`/confidence.pdf?${hash}`"
                                               target="_blank"> Политикой конфиденциальности</a>
                                               и <a :href="`/userAgr.pdf?${hash}`" target="_blank">Пользовательским соглашением</a>
                        </span>
                    </label>

                </div>
            </div>
            <div class="flex justify-center items-center text-center flex-col">
                <p class="text-mxs font-semibold">Уже есть аккаунт?
                  <span class="text-brand-light font-semibold text-mxs cursor-pointer select-none" @click="openLogin">
                     &nbsp;Войдите.</span>
              </p>
            </div>
            <button @click="login" :disabled="form.processing"
                    class="flex justify-center text-sm lg:text-base xl:text-base outline-none
                    items-center mx-auto bg-brand-light w-5/6 h-10 text-white font-semibold
                    rounded-full mt-3 lg:mt-8 xl:mt-8 hover:bg-brand-yellow hover:text-main-text">
                Зарегистрироваться
            </button>
        </div>
    </modal>
</template>

<script>
import player from '@/clients/player.js';
import Form from 'form-backend-validation';
import ModalMixin from '../../../mixins/modals';
import getCookie from '../../../mixins/getCookie';
import Modal from '@/views/modals/base-modal';
import base from '@/clients/base.js';

const uuidv4 = require('uuid/v4');

export default {
  name: 'SingUp',
  components: { Modal },
  props: ['sing_up'],
  mixins: [ModalMixin, getCookie],
  data() {
    return {
      hash: uuidv4(),
      form: new Form({
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: '',
        roistat_first_visit: this.getCookie('roistat_first_visit'),
        roistat_visit: window.roistat && window.roistat.visit ? window.roistat.visit : '',
        utm_source: this.getCookie('mozgoUtmSource'),
        utm_content: this.getCookie('mozgoUtmContent'),
        utm_medium: this.getCookie('mozgoUtmMedium'),
        utm_term: this.getCookie('mozgoUtmTerm'),
        utm_campaign: this.getCookie('mozgoUtmCampaign'),
      }, { http: player }),
      recoveryForm: new Form({
        email: '',
      }, { http: base }),
      ext: '',
      show: false,
      loaded: false,
    };
  },

  methods: {
    openLogin() {
      this.$emit('openLogin');
      this.vale = !this.vale;
    },
    login() {
      this.form.post('/')
        .then(() => {
          this.$emit('login', { sign_up: true });
          this.vale = !this.vale;
        });
    },
    sand_email() {
      this.recoveryForm.email = this.form.email;
      this.recoveryForm.post('password/email').then((response) => {
        this.$emit('email_sent', { recovery_account: true });
      });
    },
  },
  computed: {
    send_again() {
      if (this.form.errors.first('email')) {
        return !!this.form.errors.first('email').length;
      }
      return false;
    },
  },
};

</script>

<style scoped>
    .border-brand {
        outline: none;
        border-bottom-color: #bd006c !important;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 1px;
    }

    label span {
      font-size: 10px;
      line-height: 12px;
    }
    label span a{
      @apply text-brand-light underline;
    }

    .send-again {
      transition: all .4s ease;
    }
    @media only screen and (min-width: 317px) and (max-width: 330px) {
        .iphone-padding-mb-5  {
            margin-bottom: 0.1rem !important;
        }
    }
</style>
